import FilterBlock from "@/api/query/filters/filter-block";

/**
 * Родительский класс фильтров
 */
export default class Filter extends FilterBlock {
    /**
     * @param {string} field
     * @param {*} value
     */
    constructor(field, value) {
        super();

        if (new.target === Filter) {
            throw new TypeError("Cannot construct Filter instances directly");
        }

        if (!this.getOperator()) {
            throw new TypeError("Must override method getOperator");
        }

        this.field = field;
        this.value = value;
    }

    /**
     * @returns {string}
     */
    getField() {
        return this.field;
    }

    /**
     * @returns {*}
     */
    getValue() {
        return this.value;
    }

    /**
     * @returns {string}
     */
    getOperator() {
        return "";
    }
}
